import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Cotista } from "./cotista.model";
import { AgenteFinanceiro } from "./agente-financeiro.model";

export class ParticipanteConglomerado extends BaseEntity{
    public id: number;
    public agenteFinanceiro: AgenteFinanceiro;
    public dataInicial: Date;
    public dataFinal: Date;
    public codigo: string;
    public percentual: number;
    public situacao: string;
    public dataRegistro: Date;
    public valorTotal: number;
    public nomeUsuarioADResponsavel: string;
    public idConglomerado: number;
}

